"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconNext = function IconNext(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "23px",
    height: "44px",
    className: (0, _classnames.default)('Icon', 'IconNext', className),
    style: style,
    viewBox: "0 0 23 44"
  }, _react.default.createElement("g", {
    id: "SprinklrU-Home",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "SprinklrU---Home---Carousel-in-Banner",
    transform: "translate(-1337.000000, -307.000000)",
    fill: "#E3E3E3"
  }, _react.default.createElement("path", {
    d: "M1337.21967,349.21967 C1336.92678,349.512563 1336.92678,349.987437 1337.21967,350.28033 C1337.51256,350.573223 1337.98744,350.573223 1338.28033,350.28033 L1359.81066,328.75 L1338.28033,307.21967 C1337.98744,306.926777 1337.51256,306.926777 1337.21967,307.21967 C1336.92678,307.512563 1336.92678,307.987437 1337.21967,308.28033 L1357.68934,328.75 L1337.21967,349.21967 Z",
    id: "Path-5-Copy"
  }))));
};

var _default = IconNext;
exports.default = _default;